import { useSelector } from 'react-redux';

import { usePage } from '../contexts/usePageContext';
import { RootState } from '../redux/store';
import { StructureType } from '../types/types';

export const useCurrentStructure = (): StructureType[] => {
 const { pageName } = usePage();
 return useSelector((state: RootState): StructureType[] => {
  const pageState = state[pageName as keyof RootState];

  return pageState && 'structure' in pageState
   ? (pageState.structure as StructureType[])
   : [];
 });
};

